import api from '../callApi';
import { parseAddressNumber, parseAddressStreet } from '../addressParser';

const apiCompleteFindPollingStation = (apiRequestData, values, actionCompletedTime) => {
    const request = {
        ...apiRequestData,
        street: parseAddressStreet(values.address),
        streetNo: parseAddressNumber(values.address),
        zipCode: values.postalCode,
        actionCompletedTime: actionCompletedTime
    };

    return api
        .post('Widget/CompleteFindPollingStationAsync', request, { useFingerprint: true })
        .then(response => {
            return response;
        });
};

export default apiCompleteFindPollingStation;
